/**
 * components/riskTerminal/signin.js
 *
 * upstox-053 — Upstox sign-in opens in a NEW tab; the terminal and Settings
 * never leave. The backend's callback 302s (return target `popup`, on the
 * server's fixed list) to the app's own #upstox-signed-in page, which tells
 * every other tab of the app "signed in" — over a BroadcastChannel, and a
 * localStorage write as the `storage`-event fallback (both same-origin only,
 * which is why the callback must land on the app first) — then closes itself.
 */

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const CHANNEL = 'upstox-signin';
const KEY = 'upstox.signedInAt';

export const UPSTOX_POPUP_LOGIN = `${API}/upstox/login?return_to=popup`;

/** Open Upstox's login in a new tab — from the click itself, so no popup blocker. */
export function openUpstoxSignin(e, url = UPSTOX_POPUP_LOGIN) {
  if (e && e.preventDefault) e.preventDefault();
  const w = window.open(url, '_blank');
  if (w) { try { w.opener = null; } catch (err) { /* cross-origin later: fine */ } }
  return w;
}

/** The signed-in page: tell the other tabs. */
export function announceSignedIn() {
  const at = String(Date.now());
  try { const ch = new BroadcastChannel(CHANNEL); ch.postMessage({ type: 'signed-in', at }); ch.close(); } catch (e) { /* old browser: storage below */ }
  try { window.localStorage.setItem(KEY, at); } catch (e) { /* storage blocked */ }
}

/** Call `cb` when another tab announces a sign-in; returns the unsubscribe. */
export function onUpstoxSignedIn(cb) {
  let ch = null;
  try { ch = new BroadcastChannel(CHANNEL); ch.onmessage = m => { if (m && m.data && m.data.type === 'signed-in') cb(); }; } catch (e) { ch = null; }
  const onStorage = ev => { if (ev.key === KEY) cb(); };
  window.addEventListener('storage', onStorage);
  return () => { if (ch) ch.close(); window.removeEventListener('storage', onStorage); };
}
